import { useEffect, useState } from "react";
import { api } from "../api/client";

// The playbook catalogue as GET /help/playbooks serves it (backend/src/lib/playbooks.ts),
// fetched once per page load and shared by every chip and link that names a playbook.

export interface PlaybookSummary {
  id: string;
  code: string;
  title: string;
  summary: string;
  when: string;
  steps: number;
}

let pending: Promise<PlaybookSummary[]> | null = null;

export function loadPlaybooks(): Promise<PlaybookSummary[]> {
  if (!pending) {
    pending = api.get<{ playbooks: PlaybookSummary[] }>("/help/playbooks")
      .then((d) => d.playbooks)
      .catch((e) => { pending = null; throw e; });
  }
  return pending;
}

export function usePlaybooks(): PlaybookSummary[] | null {
  const [list, setList] = useState<PlaybookSummary[] | null>(null);
  useEffect(() => {
    let cancelled = false;
    loadPlaybooks().then((l) => { if (!cancelled) setList(l); }).catch(() => { if (!cancelled) setList([]); });
    return () => { cancelled = true; };
  }, []);
  return list;
}

/** "IR-3" → the playbook whose criteria carry the IR prefix. */
export function playbookForCriterion(list: PlaybookSummary[], criterionId: string): PlaybookSummary | undefined {
  const code = criterionId.split("-")[0];
  return list.find((p) => p.code === code);
}

export const playbookPath = (id: string) => `/help/playbooks/${encodeURIComponent(id)}`;
export const libraryPath = (id: string, part?: number) =>
  `/help/library/${encodeURIComponent(id)}${part ? `?part=${part}` : ""}`;
